/**
 * Swim to top
 */
var $backToTopButton = $('.js-back-to-top');

$(window).scroll(function() {
  if ($(document).scrollTop() > 300) {
    $backToTopButton.addClass('visible');
  }
  else {
    $backToTopButton.removeClass('visible');
  }
});

$backToTopButton.on('click', function(e) {
  $([document.documentElement, document.body]).animate({
    scrollTop: 0,
  }, 500);
});


/**
 * Navigation position fix
 */
$('.Header__MainNav .DropdownMenu').each(function() {
  var dropdown = $(this);
  var position = dropdown.position();
  var width = dropdown.outerWidth();
  var endPosition = position.left + width;

  if (endPosition > window.outerWidth) {
    dropdown.css({right:0});
  }    
});


/**
 * Footer Mobile Tabs
 */
$('.Footer .Footer__Title').on('click', function(e) {
  e.preventDefault();
  $(this).toggleClass('open');
});


/**
 * Color switch image udpates
 */
window.handleColorSwitchImages = function($productItem, colorHandle) {
  var setImage = function($image, imageData) {
    if (imageData) {
      $image.attr('src', imageData.url);
      $image.attr('alt', imageData.alt);
      $image.show();
    } else {
      $image.hide();
    }
  };

  if ($productItem.length) {
    var imageData = JSON.parse($productItem.find('.js-product-image-data').html());
    var $mainImage = $productItem.find('.js-product-images-main');
    var $hoverImage = $productItem.find('.js-product-images-hover');
    var $priceData = JSON.parse($productItem.find('.js-product-price-data').html());
    var $price = $productItem.find('.js-product-price');
    var $priceCompare = $productItem.find('.js-product-price-compare');
    var $discount = $productItem.find('.js-product-discount');
    var $tierOfferPrice = $productItem.find('.js-tier-offer-price');

    var colorPriceData = $priceData.find(function(price) {
      return price.color === colorHandle;
    });

    if ($price.length && colorPriceData) {
      $price.text(colorPriceData.price);
    }

    if ($priceCompare.length && colorPriceData) {
      $priceCompare.text(colorPriceData.priceCompare);
    }

    if ($discount.length && colorPriceData) {
      $discount.text(colorPriceData.discount > 0 ? `${colorPriceData.discount}% OFF` : '');
    }

    if ($tierOfferPrice.length && colorPriceData) {
      $tierOfferPrice.text(colorPriceData.tierPrice);
    }

    var colorImages = imageData.filter(function(image) {
      return image.color === colorHandle && image.oos !== true;
    });

    if (colorImages.length) {
      setImage($mainImage, colorImages[0]);
      
      const hoverColorImage = colorImages.find(function(image) {
        return image.hover;
      });

      if (hoverColorImage) {
        setImage($hoverImage, hoverColorImage);
      } else {
        setImage($hoverImage, colorImages[1]);
      }
    } else {
      var firstImage = imageData[0];
      setImage($mainImage, firstImage)
      setImage($hoverImage);
    }
  }
};

/**
 * PDP thumbnails carousel
 */

$('.Product__SlideshowNav--thumbnails .Product__SlideshowNavScroller').slick({
  slidesToShow: 7,
  infinite: false,
  draggable: false,
});


/**
 * Color switch pre-select
 */
window.handleColorSwitchPreselect = function(selectedColors) {
  var colorMatch = JSON.parse(document.querySelector('#js-color-fitlers').innerHTML.trim());

  selectedColors.forEach(function(color) {
    var colorValue = color.replace('color_', '');
    var alternativeColors = colorMatch[colorValue];

    if (alternativeColors) {
      const alternativeColorsList = alternativeColors.split(',').map(function(item) {
        return item.trim();
      });

      var colorSwatch = document.querySelectorAll('.ProductItem__ColorSwatchList');
      Array.from(colorSwatch).forEach(function(swatch) {
        var colorInputs = swatch.querySelectorAll('.ColorSwatch__Radio');  
        var foundMatch = false;

        Array.from(colorInputs).forEach(function(input) {
          var inputColor = input.dataset.color;

          if (alternativeColorsList.indexOf(inputColor) !== -1 && !foundMatch) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { 'bubbles': true }))
            foundMatch = true;
          }
        });
      });                
    } else {
      var colorInputs = document.querySelectorAll('.ProductItem__ColorSwatchList .ColorSwatch__Radio[data-color="' + colorValue + '"]');

      Array.from(colorInputs).forEach(function(input) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { 'bubbles': true }))
      });
    }
  });
};


/**
 * Announcement Slider
 */
window.addEventListener('load', function() {
  $('.AnnouncementBar__Wrapper').slick({
    autoplay: true,
  });
});


/**
 * Trask Sticky Header
 */
(function() {
  var $header = $('#section-header');
  var headerEl = $header[0];

  if (!headerEl) return;

  $(document).on('scroll', function(e) {
    var top = headerEl.getBoundingClientRect().top;

    if (!$header.hasClass('scrolled') && top === 0) {
      $header.addClass('scrolled');
    } else if ($header.hasClass('scrolled') && top > 0) {
      $header.removeClass('scrolled');
    }
  });
})();


/**
 * Custom Mobile Nav
 */
(function() {
  var activeClass = 'active';
  var openClass = 'subnav-open';

  var $mobileNavWrap = $('.js-mobile-menu');
  var $mainLinks = $('.js-mobile-nav-main-link');
  var $backLinks = $('.js-mobile-menu-back');

  // Open Subnav
  $mainLinks.on('click', function(e) {
    var handle = $(this).data('handle');
    var hasSubnav = $(this).data('has-subnav');
    
    if (handle && hasSubnav) {
      e.preventDefault();
      $('.js-mobile-menu-subnav.' + activeClass).removeClass(activeClass);
      $('.js-mobile-menu-subnav[data-parent="' + handle + '"]').addClass(activeClass);

      $mobileNavWrap.addClass(openClass);
    }
  });

  // Close Subnav
  $backLinks.on('click', function(e) {
    e.preventDefault();
    $('.js-mobile-menu-subnav.' + activeClass).removeClass(activeClass);
    $mobileNavWrap.removeClass(openClass);
  });
})();


/**
 * Trask Sticky Filters
 */
(function() {
  var $toolbar = $('.CollectionToolbar');
  if ($toolbar.length) {
    var toolbarEl = $toolbar[0];

    $(window).on('load', function() {
      var headerHeight = $('#shopify-section-header')[0].getBoundingClientRect().height;
      $toolbar.css({ top: headerHeight });

      $(document).on('scroll', function(e) {
        var top = toolbarEl.getBoundingClientRect().top;
    
        if (!$toolbar.hasClass('scrolled') && top === headerHeight) {
          $toolbar.addClass('scrolled');
        } else if ($toolbar.hasClass('scrolled') && top > headerHeight) {
          $toolbar.removeClass('scrolled');
        }
      });
    });
  }
})();

/**
 * Cart Helpers
 */
var updateCartCount = function(newQuantity) {
  var $cartCounter = $('.js-cart-counter');
  $cartCounter.addClass('is-visible');
  
  var currentCount = +$cartCounter.text();
  var newCount = currentCount + newQuantity;
  $cartCounter.text(newCount);
};

window.updateCartCount = updateCartCount;

/**
 * Free Gift
*/
var removeFreeGiftFromCart = function(refresh) {
  const settings = JSON.parse(jQuery('#js-free-gift-settings').html());
  var updates = {};
  updates[settings.product] = 0;

  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: { updates: updates },
    dataType: 'json',
    success: function(data) {
      if (refresh) {
        location.reload();
      }
    },
    error: function(error, textStatus) {
      console.log(error);
    }
  };

  $.ajax(params);
};

window.removeFreeGiftFromCart = removeFreeGiftFromCart;

var addFreeGiftToCart = function() {
  const settings = JSON.parse(jQuery('#js-free-gift-settings').html());
  if (settings.active && !settings.isInCart) {
    var params = {
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: settings.product,
        'properties[Info]': 'Free Gift'
      },
      dataType: 'json',
      success: function(data) {
        updateCartCount(1);
        settings.isInCart = true;
        jQuery('#js-free-gift-settings').html(JSON.stringify(settings));
      },
      error: function(error, textStatus) {
        console.log(error);
      }
    };

    $.ajax(params);
  } else {
    console.log('not adding');
  }
};

window.addFreeGiftToCart = addFreeGiftToCart;

const updateProductItemColor = (item, color, simpleColor) => {
  var $item = $(item);
  var $preselectColorItem = $item.find('.ColorSwatch__Radio[data-color-handle="' + color + '"]');
  var $preselectSimpleColorItem = $item.find('.ColorSwatch__Radio[data-color-simple="' + simpleColor + '"]');

  if ($preselectColorItem.length) {
    $preselectColorItem.first().prop('checked', true);
    if ($preselectColorItem[0]) {
      $preselectColorItem[0].dispatchEvent(new Event('change', { 'bubbles': true }));
    }
  } else if ($preselectSimpleColorItem.length) {
    $preselectSimpleColorItem.first().prop('checked', true);
    $preselectSimpleColorItem[0].dispatchEvent(new Event('change', { 'bubbles': true }));
  } else {
    const $defaultItem = $item.find('.ColorSwatch__Radio');
    $defaultItem.first().prop('checked', true);;
    $defaultItem[0].dispatchEvent(new Event('change', { 'bubbles': true }));
  }
};

window.updateProductItemColor = updateProductItemColor;

const updateProductSimpleColors = (item) => {
  var colorMap = JSON.parse($('#js-color-map').html());
  $(item).find('.ColorSwatch__Radio').each(function() {
    var $item = $(this);
    var itemColor = $item.data('colorHandle');

    if (itemColor) {
      $item.data('colorSimple', colorMap[itemColor]);
      $item.attr('data-color-simple', colorMap[itemColor]);
    }
  });
};
window.updateProductSimpleColors = updateProductSimpleColors;

(function() {
  var settings = JSON.parse(jQuery('#js-free-gift-settings').html());
  var meetsMinCartValue = Number(settings.cartValue) >= (Number(settings.minCartValue) * 100);

  if (settings.isInCart && (settings.isEmptyCart || !meetsMinCartValue)) {
    removeFreeGiftFromCart(true);
  }
  
  if (!settings.isInCart && !settings.isEmptyCart && meetsMinCartValue) {
    addFreeGiftToCart();
  }
})();

(function () {
  var customSearchRules = JSON.parse($('[data-custom-search-rules]').html());

  var customPageSearch = function(query, container) {
    const matchingRule = customSearchRules.find(function(rule) {
      return rule.pattern.split(',').find((pattern) => query.includes(pattern));
    });
    
    if (matchingRule) {
      var html = '<div class="Search__ResultsCustom">'
      html += '<p class="u-h4">' + matchingRule.title + '</p>';
      html += '<a href="' + matchingRule.buttonLink + '" class="Button Button--primary">' + matchingRule.buttonLabel + '</a>';
      html += '</div>';

      container.innerHTML = html;
      return true;
    }

    return false;
  }
  
  window.customPageSearch = customPageSearch;
})();

// Search clear button
(function() {
  var searchInput = document.querySelector('.Search__Input');
  var searchInputClearBtn = document.querySelector('[data-search-clear]');

  if (searchInput && searchInputClearBtn) {
    searchInput.addEventListener('input', function(e) {
      if (e.target.value.length > 0) {
        searchInputClearBtn.classList.add('active');
      } else {
        searchInputClearBtn.classList.remove('active');
      }
    });

    searchInputClearBtn.addEventListener('click', function(e) {
      e.preventDefault();
      searchInput.value = '';
      searchInput.dispatchEvent(new Event('input'));
    });
  }
})();


(function() {
  if ($('body').hasClass('template-search')) {
    $('.ProductItem').each(function() {
      var $item = $(this);
      var selectedColor = $item.find('.ColorSwatch__Radio:checked').data('color-handle');
      handleColorSwitchImages($item, selectedColor);
    });
  }
})();

(function() {
  $('.section-faq__list--accordion h4').on('click', function(e) {
    e.preventDefault();
    $(this).closest('.section-faq__list--accordion').find('.section-faq__item.open').removeClass('open');
    $(this).parent().toggleClass('open');
  });
})();

$( window ).on('load', function() {
  $('.Product__BuyLook .ProductItem__ColorSwatchList input:checked').each(function() {
    var $input = $(this);
    $input.prop("checked", true);
    $input[0].dispatchEvent(new Event('change', { 'bubbles': true }))
  });
});

$( window ).on('load', function() {
  $('.Product__Bundle .ProductItem__ColorSwatchList .ColorSwatch__Radio--preselected').each(function() {
    var $input = $(this);
    $input.prop("checked", true);
    $input[0].dispatchEvent(new Event('change', { 'bubbles': true }))
  });
});

$(window).on('load', function() {
  new ClipboardJS('.AnnouncementBar__Content strong', {
    text: function(trigger) {
      return $(trigger).data('code');
    }
  });

  $('.AnnouncementBar__Content strong').each(function() {
    $(this).data('code', $(this).text());
    $(this).append('<span class="tooltip tooltip--hover">Click To Copy</span>');
    $(this).append('<span class="tooltip tooltip--coppied">Copied</span>');
  });

  $('.AnnouncementBar__Content strong').on('click', function(e) {
    var $item = $(this);
    $item.addClass('clicked');

    setTimeout(() => {
      $item.removeClass('clicked');
    }, 2000);
  });
});

window.addEventListener("klaviyoForms", function(e) { 
  window.dataLayer = window.dataLayer || [];

  if (e.detail.type == 'open' || e.detail.type == 'embedOpen') {
    dataLayer.push({ event: 'klaviyo_form_open', formId: e.detail.formId });
  }
  if (e.detail.type == 'submit') {
    dataLayer.push({ event: 'klaviyo_form_submit', formId: e.detail.formId });
  }
  if (e.detail.type == 'stepSubmit') {
    dataLayer.push({ event: 'klaviyo_form_step_submit', formId: e.detail.formId, stepName: e.detail.metaData.$step_name });
  }
  if (e.detail.type == 'redirectedToUrl') {
    dataLayer.push({ event: 'klaviyo_form_url_redirect', formId: e.detail.formId });
  }
  if (e.detail.type == 'close') {
    dataLayer.push({ event: 'klaviyo_form_close', formId: e.detail.formId });
  }
});

// Free Gift
(function() {
  const freeGiftAttributes = document.querySelectorAll('[data-free-gift-attribute]');
  const freeGiftWrapper = document.querySelector('[data-free-gift-wrapper]');

  if (!freeGiftWrapper) return; 
 
  const freeGifQty = freeGiftWrapper.querySelector('[data-free-gift-qty]');

  const handleAttributeChange = (e) => {
    const key = e.target.dataset.attribute;
    const value = e.target.value;
    
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          [key]: value
        }
      })
    })

    const newQty = value === 'Yes' ? 0 : 1;
    freeGifQty.value = newQty;
  };

  freeGiftAttributes.forEach((el) => { 
    el.addEventListener('change', handleAttributeChange);
  });

})();


/**	
 * Product list slider	
 */	
$('.js-product-slider').slick({	
  slidesToShow: 4,	
  infinite: true,	
  responsive: [	
    {	
      breakpoint: 1000,	
      settings: {	
        slidesToShow: 2,	
      },
    },
    {	
      breakpoint: 767,	
      settings: {	
        slidesToShow: 1,	
      },	
    },
  ],
});

/**	
 * Product list slider	
 */	
$('.js-product-slider-small').slick({	
  slidesToShow: 2,	
  infinite: true
});


/**	
 * Testimonial Slider	
 */	

$('.js-testimonial-list').each(function() {
  const $this = $(this);
  const $items = $this.find('.js-testimonial-item');
  const slides = Math.min($items.length, 5);

  $this.slick({	
    slidesToShow: slides,	
    infinite: true,	
    responsive: [	
      {	
        breakpoint: 1600,	
        settings: {	
          slidesToShow: 4,	
        },	
      },	
      {	
        breakpoint: 1200,	
        settings: {	
          slidesToShow: 3,	
        },	
      },	
      {	
        breakpoint: 1000,	
        settings: {	
          slidesToShow: 2,	
        },	
      },	
      {	
        breakpoint: 768,	
        settings: {	
          slidesToShow: 1,	
          centerMode: true,	
          centerPadding: '30px'	
        },	
      },	
    ]	
  }).on('setPosition', function (event, slick) {	
    slick.$slides.css('height', slick.$slideTrack.height() + 'px');	
  });
});

// Featured product slider
$('[data-featured-product-slider]').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  infinite: true,
}).on('afterChange', function (event, currentSlide) {
  $('[data-featured-product-thumbnail]').removeClass('current');
  $('[data-featured-product-thumbnail][data-slide="' + currentSlide.currentSlide + '"]').addClass('current');
});

$('[data-featured-product-thumbnail]').on('click', function (e) {
  e.preventDefault();
  $('[data-featured-product-slider]').slick('slickGoTo', $(this).data('slide'));
});

// Featured collection slider
(() => {
  $('.cms-featured-collection__products').each(function() {
    const $this = $(this);

    new window.ProductItemColorSwatch($this[0]);

    $this.find('.ProductItem').each(function() {
      var $item = $(this);
      var selectedColor = $item.find('.ColorSwatch__Radio').first().data('color-handle');
      handleColorSwitchImages($item, selectedColor);
    });
  });
  
})();

// Custom add to cart button
(() => {
  $(document).on('click', 'button[data-cart-add]', async function(e) {
    e.preventDefault();

    const $button = $(this);
    const id = $button.data('cart-add');

    $button.addClass('loading').removeClass('error');

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{ id, quantity: 1 }]
        })
      });

      if (!response.ok) {
        throw new Error('Failed to add item to cart');
      }

      const data = await response.json();
      window.location.href = '/cart';

    } catch (error) {
      console.error('Error:', error);
      $button.removeClass('loading').addClass('error');
    }
  });
})();

// Dynamic cart
(() => {
  const $cart = $('.Cart');

  $cart.on('click', '.QuantitySelector__Button, .CartItem__Remove', async function(e) {
    e.preventDefault();

    const $button = $(this);
    const $item = $button.closest('.CartItem');
    const $wrap = $item.closest('.Cart__Content');

    $item.addClass('loading');
    $wrap.addClass('loading');

    try {
      const response = await fetch($button.attr('href'));

      if (!response.ok) {
        throw new Error('Failed to remove item from cart');
      }

      const data = await response.text();
      const $newCart = $(data).find('.Cart');

      if (!$newCart.length) {
        window.location.reload();
        return;
      }

      $cart.html($newCart.html());
    } catch (error) {
      window.location = $button.attr('href');
    }
  });
})();

// Collection pagination
window.initAutoPagination = () => {
  const pagination = document.querySelector('[data-auto-pagination]');
  if (!pagination || pagination.dataset.autoPagination !== 'true') return;

  pagination.classList.add('Pagination--autoloader');

  const loadNextPage = () => {
    const url = pagination.querySelector('[data-next]')?.href;

    if (!url) {
      console.log('No more pages');
      return;
    }

    pagination.classList.add('loading');
    
    fetch(url)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Add new products
        const newProducts = doc.querySelector('[data-product-grid]').innerHTML;
        const productGrid = document.querySelector('[data-product-grid]');
        productGrid.innerHTML += newProducts;

        $(productGrid).find('.ProductItem').each(function() {
          var $item = $(this);
          var selectedColor = $item.find('.ColorSwatch__Radio:checked').data('color-handle');
          handleColorSwitchImages($item, selectedColor);
        })

        // Update pagination
        const newPagination = doc.querySelector('[data-auto-pagination]');
        pagination.innerHTML = newPagination.innerHTML;
      })
      .finally(() => {
        pagination.classList.remove('loading');
      });
  };



  // Set up the Intersection Observer
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        loadNextPage();
      }
    });
  }, {
    root: null,
    rootMargin: '0px',
    threshold: 0.1,
  });

  observer.observe(pagination);
};

window.initAutoPagination();


// Mobile nav
(() => {
  const subnavItems = document.querySelectorAll('.SidebarMenu .level-1--has-subnav > a');

  subnavItems.forEach((item) => {
    const wrap = item.closest('.level-1--has-subnav');

    item.addEventListener('click', function(e) {
      if (!document.body.classList.contains('ab-test-simple-mobile-nav')) {
        return;
      }

      e.preventDefault();
      wrap.classList.toggle('open');
    });
  });
})();


// Klaviyo & Gorgias conflict
(function () {
  function getGorgiasAPI() {
    return window.GorgiasChat || window.gorgias || window.Gorgias || null;
  }

  function closeChat() {
    const api = getGorgiasAPI();
    if (!api) return;
    try {
      if (typeof api.close === 'function') api.close();
      if (typeof api.hide === 'function') api.hide(); // some installs expose hide()
      // Optional: also minimize if supported
      if (typeof api.minimize === 'function') api.minimize();
    } catch (e) {}
  }

  // Listen to Klaviyo Onsite Form lifecycle events
  window.addEventListener('klaviyoForms', function (evt) {
    if (!evt || !evt.detail) return;
    const { type } = evt.detail;

    if (type === 'open') {
      closeChat();
    }
  });

  // Defensive: if a Klaviyo popup is already open on load, close chat
  // (Klaviyo often injects a wrapper with data attributes)
  document.addEventListener('DOMContentLoaded', function(){
    const klOpen = !!document.querySelector('[data-klaviyo-form-id][aria-hidden="false"], .klaviyo-form-visible');
    if (klOpen) closeChat();
  });
})();